export class SubnavDropdown {
  private readonly parentToggle: HTMLDivElement;

  public static init(): SubnavDropdown | void {
    const toggle = document.querySelector("a.subnav-toggle") as HTMLElement;
    if (toggle) return new SubnavDropdown(toggle);
  }

  constructor(private readonly toggle: HTMLElement) {
    this.parentToggle = this.toggle.parentElement as HTMLDivElement;

    const resizeObserver = new ResizeObserver((entries) => {
      let width: number;
      entries.forEach((e) => (width = e.borderBoxSize[0].inlineSize));
      return width <= 992 ? this.toggleDropdown() : null;
    });

    resizeObserver.observe(this.toggle);
  }

  private toggleDropdown(): void {
    let heightNavigation: number = 0;
    let heightToggle: number = this.toggle.getBoundingClientRect().height;

    this.parentToggle
      .querySelectorAll<HTMLAnchorElement>("a")
      .forEach((nav) => {
        heightNavigation += nav.getBoundingClientRect().height;
      });

    this.parentToggle.style.setProperty("--height", `${heightToggle}px`);

    this.toggle.addEventListener("click", () => {
      if (!this.parentToggle.classList.contains("active")) {
        this.parentToggle.style.setProperty(
          "--height",
          `${heightNavigation}px`
        );
        this.parentToggle.classList.add("active");
      } else {
        this.parentToggle.style.setProperty("--height", `${heightToggle}px`);
        this.parentToggle.classList.remove("active");
      }
    });
  }
}
